import {default as Component} from './LogoComponent'

const LogoComponent = Component

export default LogoComponent



// WEBPACK FOOTER //
// ./src/components/LogoComponent/index.js